import paths from "../../shared/route/paths";
import Supplier from "./Supplier.page";

export const SupplierModule = {
  isPrivate: false,
  routers: {
    path: paths.SUPPLIER,
    component: Supplier,
  },
};
